import request from "./request";

export default async function getBindPageNameByUserId() {
  return await request.get(
    "/spin/dataAuthorizationPlayer/getBindPageNameByUserId"
  );
}
